import { CsvUpload } from '@/components/dataset/CsvUpload';
import { DatasetTable } from '@/components/dataset/DatasetTable';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Database, Plus } from 'lucide-react';
import * as React from 'react';

function EmptyState({ onUpload }: { onUpload: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-md border border-dashed py-16 text-center">
      <Database className="mb-3 h-10 w-10 text-muted-foreground" />
      <h3 className="text-base font-medium">No datasets yet</h3>
      <p className="mt-1 max-w-sm text-sm text-muted-foreground">
        Upload a numeric CSV to start running discoveries.
      </p>
      <Button className="mt-4" onClick={onUpload}>
        <Plus className="mr-1 h-4 w-4" /> Upload CSV
      </Button>
    </div>
  );
}

export default function Datasets() {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Datasets</h1>
          <p className="text-sm text-muted-foreground">Upload and manage CSVs for discovery.</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button>
              <Plus className="mr-1 h-4 w-4" /> Upload CSV
            </Button>
          </DialogTrigger>
          <DialogContent className="w-[min(95vw,1200px)] max-w-none">
            <DialogHeader>
              <DialogTitle>Upload a CSV</DialogTitle>
              <DialogDescription>
                Numeric columns only · max 5MB · up to 100,000 rows · up to 200 columns.
              </DialogDescription>
            </DialogHeader>
            <CsvUpload onUploaded={() => setOpen(false)} />
          </DialogContent>
        </Dialog>
      </div>

      <DatasetTable emptyState={<EmptyState onUpload={() => setOpen(true)} />} />
    </div>
  );
}
